import stringify, { StringifyOptions, UrlObject } from "query-string";

const DEFAULT_SETTINGS = {
  arrayFormat: "comma",
} as const as StringifyOptions;

export function stringifyUrl(url: UrlObject, settings = {}) {
  return stringify.stringifyUrl(url, { ...DEFAULT_SETTINGS, ...settings });
}

export function parseQuery<T>(query: string, settings = {}) {
  return stringify.parse(query, {
    ...DEFAULT_SETTINGS,
    parseBooleans: true,
    parseNumbers: true,
    ...settings,
  }) as T;
}

export function stringifyQuery(obj: Record<string, unknown>, settings = {}) {
  return stringify.stringify(obj, { ...DEFAULT_SETTINGS, ...settings });
}
